$(document).ready(function () {
	//$("select").toggleClass("form-control");
	//$("#deviceMake").addClass("form-control");
	//$("#deviceModel").addClass("form-control"); 

});